export var getReservationDisplayGuestCounts = function (reservation) { var _a, _b; return (_b = (_a = reservation === null || reservation === void 0 ? void 0 : reservation.displayGuestCounts) !== null && _a !== void 0 ? _a : reservation === null || reservation === void 0 ? void 0 : reservation.guestCounts) !== null && _b !== void 0 ? _b : []; };
export var sumGuestCountsByAgeCategory = function (reservations, ageCategoryIds) {
    var _a;
    return (_a = reservations === null || reservations === void 0 ? void 0 : reservations.reduce(function (total, reservation) { return (total + getReservationDisplayGuestCounts(reservation).reduce(function (subtotal, guestCount) {
        var _a;
        return (ageCategoryIds.includes(guestCount.ageCategoryId)
            ? subtotal + ((_a = guestCount.count) !== null && _a !== void 0 ? _a : 0)
            : subtotal);
    }, 0)); }, 0)) !== null && _a !== void 0 ? _a : 0;
};
